// Anchor IDs for the consolidated Delivery & Location Settings page
// (DATA-4953). They match the existing /brand_content tab keys so
// DATA-4954's deep links land on the right section without an
// id-translation layer.
//
// Lives in src/constants (not the scene) so the Settings nav — a
// component — can build its deep-link hashes from the same source the
// scene renders without importing across the scene boundary. The nav
// test asserts every hash here resolves to a real section, so the two
// can't drift.
export const SECTION_IDS = {
  deliveryDefault: 'delivery_default_logic',
  locationSelection: 'preferences_modal_setting',
  orderingConfiguration: 'ordering_configuration',
} as const
